import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Vehicle } from "../components/utility/utility-classes";
import * as columns from "./columns.json";
import { Observable } from "rxjs";
import { AnnouncementEditorComponent } from "../components/homepage/announcement-editor/announcement-editor.component";

@Injectable({
  providedIn: "root",
})
export class WriterService {
  constructor(private readonly http: HttpClient) {}

  public getUrl(table: string, ids: any[]): URL {
    return new URL(
      `/crud/rest/${table}?${new URLSearchParams(
        (ids /*??*/ || []).map((id) => ["id", id])
      )}`,
      environment.serviceURL
    );
  }

  public processRecord(
    record: any,
    table: string,
    method: string
  ): Observable<any> {
    let url: string = String(
      this.getUrl(table, this.getTableParams(table, record))
    );
    if (!(record instanceof Array)) {
      record = this.getTableObject(table, record);
    } else {
      record = this.getTableObjects(table, record);
      url = environment.serviceURL + "/crud/rest/" + table + "/values";
    }

    switch (method) {
      case "PUT":
        return this.http.put<any>(url, record);
      case "POST":
        return this.http.post<any>(url, record);
      case "DELETE":
        return this.http.delete<any>(url, record);
    }
  }

  public deleteRecord(vehicleId: string): Observable<any> {
    return this.http.delete<any>(
      `${environment.serviceURL}/vehicle?vehicleId=${encodeURIComponent(
        vehicleId
      )}`
    );
  }

  public updateSegmentChangeSubscription(
    record: any,
    method: string
  ): Observable<any> {
    const url: string = String(
      this.getUrl(
        "segmentSubscription",
        this.getTableParams("user_subscription", record)
      )
    );
    url.replace("user_subscription", "segmentSubscription");
    record = this.getTableObject("user_subscription", record);
    if (method === "subscribe") {
      return this.http.post<any>(url, record);
    } else {
      return this.http.delete<any>(url, record);
    }
  }

  public uploadFiles(
    vehicle: Vehicle,
    type: string,
    createdby: string,
    created: string
  ): Observable<any> {
    const form = new FormData();
    form.append("createdby", createdby);
    form.append("created", created);
    switch (type) {
      case "image":
        if (vehicle.fphotofront != null) {
          form.append("filename", vehicle.id + vehicle.fphotofront.name);
          form.append(
            "photofront",
            vehicle.fphotofront,
            vehicle.fphotofront.name
          );
        }
        if (vehicle.fphotorear != null) {
          form.append("filename", vehicle.id + vehicle.fphotorear.name);
          form.append("photorear", vehicle.fphotorear, vehicle.fphotorear.name);
        }
        if (vehicle.fphotoside != null) {
          form.append("filename", vehicle.id + vehicle.fphotoside.name);
          form.append("photoside", vehicle.fphotoside, vehicle.fphotoside.name);
        }
        if (vehicle.fphotointerior != null) {
          form.append("filename", vehicle.id + vehicle.fphotointerior.name);
          form.append(
            "photointerior",
            vehicle.fphotointerior,
            vehicle.fphotointerior.name
          );
        }
        break;
      case "attachments":
        form.append("filename", vehicle.id + "-" + vehicle.attachment.name);
        form.append("attachments", vehicle.attachment, vehicle.attachment.name);
        break;
    }
    return this.http.post(
      `${environment.serviceURL}/vehicle/file?vehicleid=${encodeURIComponent(
        vehicle.id
      )}`,
      form
    );
  }

  public getTableObject(table: string, source: any): { [p: string]: any } {
    // @ts-ignore
    const tableInfo = columns.default[table];
    const tableColumns: string[] = Object.keys(tableInfo.columns);
    return Object.fromEntries(
      Object.entries(source).filter(
        ([key, val]) => tableColumns.includes(key) && val != null
      )
    );
  }

  public getTableObjects(table: string, source: any[]): { [p: string]: any } {
    return source.map((s) => this.getTableObject(table, s));
  }

  private getTableParams(table: string, record: any): any[] {
    const params: any[] = [];
    // @ts-ignore
    columns.default[table].keys.forEach((key) => params.push(record[key]));
    return params;
  }

  public deleteFile(filename: string, type: string): Observable<any> {
    return this.http.delete(
      `${environment.serviceURL}/file?type=${encodeURIComponent(
        type
      )}&filename=${encodeURIComponent(filename)}`
    );
  }

  public deleteBodystyle(bodystyleId: any): Observable<ArrayBuffer> {
    return this.http.delete(
      `${environment.serviceURL}/deleteBodystyle?bodystyleId=${bodystyleId}`,
      bodystyleId
    );
  }

  public deletePropulsion(propulsionId: any): Observable<ArrayBuffer> {
    return this.http.delete(
      `${environment.serviceURL}/deletePropulsion?propulsionId=${propulsionId}`,
      propulsionId
    );
  }

  public setUserColumnForViews(
    gminId: string,
    viewName: string,
    columnName: string
  ): Observable<any> {
    return this.http.get<any>(
      `${environment.serviceURL}/setUserViewColumn?gminId=${gminId}&viewName=${viewName}&columnName=${columnName}`
    );
  }

  public updateBrandForPropulsion(
    vehId: string,
    brand: string
  ): Observable<any> {
    return this.http.post(
      `${environment.serviceURL}/updateBrandForPropulsion`,
      { vehId, brand }
    );
  }
}
